import produce from "immer";
import { SET_GRID_INSTANCE, SET_GRID_STATE_ID } from "./actions";

const defaultState = {
  gridStateId: null,
  gridInstance: null,
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_GRID_INSTANCE:
      state.gridInstance = action.gridInstance;
      break;
    case SET_GRID_STATE_ID:
      state.gridStateId = action.gridStateId;
      break;
    default:
      return state;
  }
});

export default reducer;
